var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<p class=\"next-times-service-unavailable-prompt\" translate translate-params-service=\"$ctrl.service.name\">Valitettavasti palvelua <strong>{{ service }}</strong> ei voi varata verkossa tähän toimipisteeseen.\n</p>\n<p class=\"next-times-service-unavailable-prompt\">\n<span translate translate-comment=\"Jatkuu: ...tai soita asiakaspalveluun\">Etsi sopivaa toimipistettä verkkoajanvarauksen kautta tai</span>\n<span style=\"text-transform: lowercase\" translate>Soita asiakaspalveluun varataksesi ajan: <a href=\"tel:+358104003400\">010 400 3400</a></span>\n</p>\n<normal-button link=\"{{ $ctrl.serviceBookingUrl }}\">\n<span translate translate-comment=\"Näytetään seuraavien aikojen komponentissa kun toimipisteeseen ei voi varata aikaa verkossa. Linkkinappi ajanvaraukseen tälle palvelulle.\">\nKatso aikoja\n</span>\n</normal-button>\n";
var id1="app/next-times/offline-service.tpl.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;


//////////////////
// WEBPACK FOOTER
// ./src/app/next-times/offline-service.tpl.html
// module id = 461
// module chunks = 0